import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { FacilitySinglePageDtoSchema } from '../contracts';

const _GetFacilityByIdRequestDtoSchema = z.object({
  facilityId: z.number(),
});

const GetFacilityByIdResponseDtoSchema = FacilitySinglePageDtoSchema;

export type GetFacilityByIdRequestDto = z.infer<
  typeof _GetFacilityByIdRequestDtoSchema
>;
export type GetFacilityByIdResponseDto = z.infer<
  typeof GetFacilityByIdResponseDtoSchema
>;

export const getFacilityById = (
  params: GetFacilityByIdRequestDto,
  config?: AxiosRequestConfig<GetFacilityByIdRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/facilities/${facilityId}`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetFacilityByIdResponseDtoSchema));
};
